import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useHistory } from 'react-router-dom'
import { Animation } from 'rsuite'
 
import HeaderContactItem from './header-contact-item'
import LanguageSwitch from './language-switch'

import * as scripts from './../scripts/scripts' 

import { Spin as Hamburger } from 'hamburger-react'

import logo from './../img/benox-logo-white.png'
import icoAddres from './../img/icons/ICO_addres.png'
import icoEmail from './../img/icons/ICO_email.png'
import icoPhone from './../img/icons/ICO_phone.png'

const { Collapse } = Animation

const MaxMobileWidth = 640

const Header = () => {
  const { t } = useTranslation()
  
  const [ mobileMenu, setMobileMenu ] = useState(checkMenuType())
  const [ openMenu, setOpenMenu ] = useState(false)

  const history = useHistory()

  history.listen(location => {
    setOpenMenu(false)
  })

  useEffect(() => {
    function HandleWindowResize() {
      setMobileMenu(checkMenuType())
      setOpenMenu(false)    
    }
    window.addEventListener('resize', HandleWindowResize)
  })
  
  function checkMenuType() {
    return window.innerWidth < MaxMobileWidth
  }

  const Menu = ({ ...props}) => {
    return (
      <ul {...props}>
        <li><Link to="/">{t('Home')}</Link></li>
        <li><Link to={{
          pathname: "/",
          state: {
            aboutBenox: true
          }
        }}>{t('About us')}</Link></li>
        <li><Link to="/products">{t('Products catalog')}</Link></li>
        <li><Link to="/contact">{t('Contact')}</Link></li>
      </ul>
    )
  }


  return ( 
    <div className={`header ${mobileMenu ? 'for-mobile' : 'for-web'}`}>
      <div className="header-first-line">
        <div className="content">
          <div className="header-logo">
            <Link to="/">
              <img src={logo} alt="" />
            </Link>
          </div>
          { !scripts.msieversion() && (
            <>
            <div className="header-contact">
              <HeaderContactItem
                icon={icoAddres}
                content={t("Asnyka str. 2\n84-217 Kamień")}
              />
              <HeaderContactItem
                icon={icoPhone}
                content="+48 58 676 14 91"
                link="tel:+48586761491"
              />
              <HeaderContactItem
                icon={icoEmail}
                content="info@benox.pl"
                link="mailto:info@benox.pl"
              />
            </div>
            <LanguageSwitch/>
            {mobileMenu && <Hamburger toggled={openMenu} toggle={setOpenMenu} size={36}/>}
          </>
          )}
        </div>
      </div>      
      { !scripts.msieversion() && (
        <div className="header-second-line">
          <div className="content">
            <nav className={`menu-${mobileMenu ? 'mobile' : 'web'}`}>   
              {mobileMenu ? (
                <Collapse in={openMenu}>
                  {(props) => <Menu {...props}/>}
                </Collapse>
              ) : (
                <Menu />
              )}     
            </nav>
          </div>
        </div>
      )}
    </div>
  )
}

export default Header